let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("7S9EX")]).then(() => parcelRequire('3VmKy'));